// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"225":"5e1949b1","354":"33c4d258","601":"ff5f6185","838":"11ced220"}[chunkId] + ".js";
};